// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured-clips-view-more-modal .modal2__container {
    width: 640px;
    max-height: 90vh;
}

.featured-clips-view-more-modal__container {
    padding: 18px 25px 24px 25px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
}

.featured-clips-view-more-modal__reel {
    position: relative;
    height: 310px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.featured-clips-view-more-modal__reel.lock {
    opacity: 70%;
}

.featured-clips-view-more-modal__reel .hubicon-lock_fill {
    font-size: 24px;
    position: absolute;
}

.featured-clips-view-more-modal__reel .hubicon-lock_fill::before {
    color: var(--white-color);
}

.featured-clips-view-more-modal__reel-video {
    width: 180px;
    height: 310px;
    background-color: var(--new-gray-background-color);
    border-radius: 8px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.featured-clips-view-more-modal__reel-video .hubicon-video_library,
.featured-clips-view-more-modal__reel-video .hubicon-video_camera_front{
    font-size: 30px;
    color: var(--basic-gray-color);
}
.featured-clips-view-more-modal__reel-video .hubicon-video_library::before {
    color: var(--basic-gray-color);
}

.featured-clips-view-more-modal__reel-video__empty-title {
    position: absolute;
    bottom: 32%;
    left: 12%;
    text-align: center;
    width: 70%;
}

.featured-clips-view-more-modal__reel-video__empty-title.baloa-table-column {
    color: var(--basic-gray-color);
}

.featured-clips-view-more-modal__reel-video__title {
    position: absolute;
    bottom: 10px;
    left: 8px;
    display: -webkit-box;             /* Usar el modelo de caja flexible para webkit */
    -webkit-box-orient: vertical;     /* Orientar la caja en modo vertical */
    -webkit-line-clamp: 2;            /* Mostrar un máximo de 2 líneas */
    overflow: hidden;
    text-overflow: ellipsis;    
    max-height: calc(calc(var(--space) + var(--space-eighth))*2);
    /* height: calc(calc(var(--space) + var(--space-eighth))*2); */
    margin: 0; 
}

.featured-clips-view-more-modal__reel-video__title.baloa-table-column {
    color: var(--white-color);
}

.featured-clips-view-more-modal__reel_media_video{
    width: 180px;
    height: 310px;
    border-radius: 8px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    object-fit: cover;
}

.featured-clips-view-more-modal__reel_media_video_container{
    width: 180px;
    height: 310px;
    margin-bottom: 10px;
}

.featured-clips-view-more-modal__reel_media_video_fit{
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .featured-clips-view-more-modal .modal2__container {
        margin: 0;
        height: 100%;
        max-height: unset;
        border-radius: 0;
        background: var(--new-background-color);
    }

    .featured-clips-view-more-modal .modal2__header {
        padding-bottom: 16px;
    }

    .featured-clips-view-more-modal .modal2__header__title.baloa-subtitle-2 {
        font-size: 18px;
    }

    .featured-clips-view-more-modal .modal2__content {
        background: var(--new-background-color);
    }

    .featured-clips-view-more-modal__reel {
        height: 191px;
    }

    .featured-clips-view-more-modal__reel_media_video {
        width: 111px;
        height: 191px;
    }

    .featured-clips-view-more-modal__reel_media_video_container {
        width: 111px;
        height: 191px;
    }

    .featured-clips-view-more-modal__container {
        gap: 8px;
        padding: 17px 13px;
    }

    .featured-clips-view-more-modal__reel-video {
        width: 111px;
        height: 191px;
    }

    .featured-clips-view-more-modal__reel-video .hubicon-video_library, 
    .featured-clips-view-more-modal__reel-video .hubicon-video_camera_front {
        font-size: 24px;
    }

    .featured-clips-view-more-modal__reel-video__empty-title {
        bottom: 25%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-featured-clips-view-more-modal/ProfileFeaturedClipsViewMoreModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,oBAAoB,cAAc,gDAAgD;IAClF,4BAA4B,MAAM,sCAAsC;IACxE,qBAAqB,aAAa,kCAAkC;IACpE,gBAAgB;IAChB,uBAAuB;IACvB,4DAA4D;IAC5D,8DAA8D;IAC9D,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,uCAAuC;IAC3C;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".featured-clips-view-more-modal .modal2__container {\n    width: 640px;\n    max-height: 90vh;\n}\n\n.featured-clips-view-more-modal__container {\n    padding: 18px 25px 24px 25px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n}\n\n.featured-clips-view-more-modal__reel {\n    position: relative;\n    height: 310px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.featured-clips-view-more-modal__reel.lock {\n    opacity: 70%;\n}\n\n.featured-clips-view-more-modal__reel .hubicon-lock_fill {\n    font-size: 24px;\n    position: absolute;\n}\n\n.featured-clips-view-more-modal__reel .hubicon-lock_fill::before {\n    color: var(--white-color);\n}\n\n.featured-clips-view-more-modal__reel-video {\n    width: 180px;\n    height: 310px;\n    background-color: var(--new-gray-background-color);\n    border-radius: 8px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.featured-clips-view-more-modal__reel-video .hubicon-video_library,\n.featured-clips-view-more-modal__reel-video .hubicon-video_camera_front{\n    font-size: 30px;\n    color: var(--basic-gray-color);\n}\n.featured-clips-view-more-modal__reel-video .hubicon-video_library::before {\n    color: var(--basic-gray-color);\n}\n\n.featured-clips-view-more-modal__reel-video__empty-title {\n    position: absolute;\n    bottom: 32%;\n    left: 12%;\n    text-align: center;\n    width: 70%;\n}\n\n.featured-clips-view-more-modal__reel-video__empty-title.baloa-table-column {\n    color: var(--basic-gray-color);\n}\n\n.featured-clips-view-more-modal__reel-video__title {\n    position: absolute;\n    bottom: 10px;\n    left: 8px;\n    display: -webkit-box;             /* Usar el modelo de caja flexible para webkit */\n    -webkit-box-orient: vertical;     /* Orientar la caja en modo vertical */\n    -webkit-line-clamp: 2;            /* Mostrar un máximo de 2 líneas */\n    overflow: hidden;\n    text-overflow: ellipsis;    \n    max-height: calc(calc(var(--space) + var(--space-eighth))*2);\n    /* height: calc(calc(var(--space) + var(--space-eighth))*2); */\n    margin: 0; \n}\n\n.featured-clips-view-more-modal__reel-video__title.baloa-table-column {\n    color: var(--white-color);\n}\n\n.featured-clips-view-more-modal__reel_media_video{\n    width: 180px;\n    height: 310px;\n    border-radius: 8px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    object-fit: cover;\n}\n\n.featured-clips-view-more-modal__reel_media_video_container{\n    width: 180px;\n    height: 310px;\n    margin-bottom: 10px;\n}\n\n.featured-clips-view-more-modal__reel_media_video_fit{\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .featured-clips-view-more-modal .modal2__container {\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n        border-radius: 0;\n        background: var(--new-background-color);\n    }\n\n    .featured-clips-view-more-modal .modal2__header {\n        padding-bottom: 16px;\n    }\n\n    .featured-clips-view-more-modal .modal2__header__title.baloa-subtitle-2 {\n        font-size: 18px;\n    }\n\n    .featured-clips-view-more-modal .modal2__content {\n        background: var(--new-background-color);\n    }\n\n    .featured-clips-view-more-modal__reel {\n        height: 191px;\n    }\n\n    .featured-clips-view-more-modal__reel_media_video {\n        width: 111px;\n        height: 191px;\n    }\n\n    .featured-clips-view-more-modal__reel_media_video_container {\n        width: 111px;\n        height: 191px;\n    }\n\n    .featured-clips-view-more-modal__container {\n        gap: 8px;\n        padding: 17px 13px;\n    }\n\n    .featured-clips-view-more-modal__reel-video {\n        width: 111px;\n        height: 191px;\n    }\n\n    .featured-clips-view-more-modal__reel-video .hubicon-video_library, \n    .featured-clips-view-more-modal__reel-video .hubicon-video_camera_front {\n        font-size: 24px;\n    }\n\n    .featured-clips-view-more-modal__reel-video__empty-title {\n        bottom: 25%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
